<div *ngIf="!isLoading && noDataAvailable" class="no-data-container text-center p-20">
    <div class="d-flex flex-column align-items-center">
        <i-tabler name="info-circle" class="icon-30 text-muted"></i-tabler>
        <h5 class="f-w-600">{{ 'LABEL.NO_DATA' | translate }}</h5>
        <p class="f-w-600 mat-subtitle-1 f-s-16 m-l-10">
        </p>
    </div>
</div>

<div *ngIf="!noDataAvailable" class="patient-report-dialog" [class.patient-report-dialog-modal]="isDialog">
    <mat-dialog-actions class="report-dialog-header d-flex justify-content-between align-items-center">
        <div class="dialog-title">
            <h4 class="f-s-18 f-w-600 m-0" *ngIf="isDialog">
                {{'ENTITY.PATIENT'| translate}} {{ 'LABEL.REPORT' | translate }}
            </h4>
        </div>
        <div *ngIf="!noDataAvailable" class="d-flex align-items-center gap-2">
            <mat-checkbox [(ngModel)]="showCategory" class="m-0">
                Category & SubCategory
            </mat-checkbox>
            <a mat-icon-button *ngIf="Prescriptions.length === 0" (click)="printReportDirect()">
                <i-tabler name="printer" class="text-primary icon-30 d-flex"></i-tabler>
            </a>
            <a mat-icon-button *ngIf="Prescriptions.length > 0" [matMenuTriggerFor]="menu">
                <i-tabler name="printer" class="text-primary icon-30 d-flex"></i-tabler>
            </a>

            <mat-menu #menu="matMenu">
                <a mat-menu-item (click)="printReportDirect()">All</a>
                <a mat-menu-item (click)="printReportOnly()">Report Only</a>
                <a mat-menu-item (click)="printPrescriptionOnly()">Prescription</a>
            </mat-menu>
        </div>
    </mat-dialog-actions>

    <mat-divider *ngIf="isDialog"></mat-divider>

    <div class="report-scroll-container p-24">
        <mat-card class="report-card m-l-5">
            <!-- Patient Info Section -->
            <div class="d-flex justify-content-between align-items-center flex-wrap m-b-10" *ngIf="isDialog">
                <!-- Left Info -->
                <div class="left-info">
                    <div class="info-grid" *ngIf="patientDetails">
                        <label class="opd-label">{{ 'LABEL.PATIENT_NAME' | translate }}:</label>
                        <span class="opd-value">{{ patientDetails.firstName }} {{
                            patientDetails.lastName }}</span>

                        <label class="opd-label">{{ 'LABEL.GENDER' | translate }}/{{ 'LABEL.AGE' | translate
                            }}:</label>
                        <span class="opd-value" *ngIf="patientDetails">
                            {{ getGenderName(patientDetails.gender) }}/{{ patientDetails.age }}
                        </span>
                    </div>
                </div>

                <!-- Right Info -->
                <div class="right-info text-end">
                    <div class="info-grid">
                        <label class="opd-label">{{ 'LABEL.OPD_NO' | translate }}:</label>
                        <span class="opd-value">{{ reportData.opdNumber }}</span>

                        <label class="opd-label">{{ 'LABEL.OPD_DATE' | translate }}:</label>
                        <span class="opd-value">{{ reportData.appointDate | date:'dd/MM/YYYY'
                            }}</span>
                    </div>
                </div>
            </div>
            <mat-divider></mat-divider>

            <app-report-print [appointmentData]="appointmentData" [OpdData]="OpdData" [hideActionButtons]="true"
                [showCategory]="showCategory" [useInternalScroll]="false"
                (dataLoaded)="onDataLoaded()"></app-report-print>
        </mat-card>
    </div>

    <mat-divider *ngIf="isDialog"></mat-divider>

    <mat-dialog-actions *ngIf="isDialog" class="report-dialog-footer no-print">
        <div class="action-buttons">
            <a mat-stroked-button color="primary" class="m-r-10" (click)="onCloseDialog()">
                {{ 'BUTTON.BTN_CLOSE' | translate }}
            </a>
        </div>
    </mat-dialog-actions>
</div>
